import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'moneda',
    standalone: false
})
export class MonedaPipe implements PipeTransform {
  transform(valor: string | undefined): string {
    if (valor != undefined){
      return valor.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    } else {
      return '0.00';
    }
  }
}
